import useIsMobile from "../../../hooks/device/useIsMobile";
import SearchDesktop from "./Search/SearchDesktop";
import SearchInputMobile from "./Search/search-input-mobile";

function SearchModule(): JSX.Element {
  const isMobile = useIsMobile();

  return isMobile ? <SearchInputMobile /> : <SearchDesktop />;
}

export default SearchModule;
